export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14290.baa9cea4.jpg";